import React from 'react';

import { selectFiles } from '../../core/services/file.service';

import styles from './add-cover.module.scss';
interface AddFileProps {
  setFieldValue: (type: string, file: File | null) => void;
  acceptedFiles?: string[];
  errorMessage?: string | null;
  preview?: boolean;
  sourceFile?: string;
  videoSnapShot?: string;
  file?: File | null;
}

export const AddCover: React.FC<AddFileProps> = ({ file, setFieldValue }) => {
  const openFileNavigator = async () => {
    const files = await selectFiles({ accept: 'image/*' });

    if (!files || files.length === 0) {
      return;
    }
    setFieldValue('file', files[0]);
  };

  return (
    <div className={styles['folder-container']} onClick={openFileNavigator}>
      {!file ? (
        <div className={styles['uploaded-file-info']} data-dashed={!file}>
          <div className={styles['placeholder']}>Choose a cover</div>
        </div>
      ) : (
        <div className={styles['uploaded-file-info']} data-dashed={!file}>
          {file && <img className={styles['preview']} src={URL.createObjectURL(file)} />}
        </div>
      )}
    </div>
  );
};
